<template>
  <div class="container-table-datagroup full-height">
    <q-card class="my-card full-height">
      <q-card-section>
        <div class="row">
          <div class="col-12 container-app">
            <div class="row title-row">
              <div class="title">Datos del Ámbito</div>
            </div>
            <div>
              <q-toggle
                color="primary"
                v-model="visible"
                label="Visible en Catálogo"
                @input="checkToSave"
                left-label
              />
            </div>
            <div class="row q-col-gutter-md input-row">
              <div class="col-4">
                <q-input
                  data-cy="name"
                  v-model="v$.name.$model"
                  outlined
                  debounce="1000"
                  :error="v$.name.$error"
                  label="*Nombre del ámbito"
                  @input="checkToSave"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

import { QCard, QCardSection, QToggle } from 'quasar';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QCard,
    QCardSection,
    QToggle
  },
  mixins: [Message],
  props: {
    dataAmbito: Object
  },
  computed: {},
  validations: {
    name: { required }
  },
  data () {
    return {
      data: this.dataAmbito,
      name: null,
      visible: false
    };
  },
  mounted () {
    this.$eventHub.$on('HAVE_ERROR', () =>
      this.checkToSave()
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('HAVE_ERROR');
  },
  methods: {
    checkToSave () {
      this.v$.$touch();

      if (!this.v$.$error) {
        let name = this.name;

        if (name !== '' && name !== null && name !== undefined) {
          this.saveValues();
        }
      } else {
        this.$emit('validationError', true);
      }
    },
    async saveValues () {
      let name = this.name;
      let visible = this.visible;

      let dataArray = {
        name: name,
        visible: visible
      };

      this.$emit('saveData', dataArray);
      this.$emit('validationError', false);
    },
    _refillData () {
      this.name = this.data.name;
      this.visible = this.data.visible;
    }
  },
  watch: {
    dataAmbito: {
      handler: function () {
        this.data = this.dataAmbito;

        if (Object.entries(this.dataAmbito).length > 0) {
          this._refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-datagroup {
  .my-card {
    min-height: 200px;
    height: 200px;
    .input-row {
      padding: 10px 0px;
    }
  }
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
